import { bluePalette, grayPalette } from '../../themes/colors';

export const infoLightTheme = {
  color: grayPalette[600],
  textUnderlineColor: bluePalette[700],
};
